<template lang="pug">
tr(@click="edit")
  td {{ customField.fieldName }}
  td {{ customField.fieldCode }}
  td {{ customField.description }}
  td {{ customField.datatype }}
  td {{ customField.optional ? 'Yes' : 'No' }}
  td 
    button.table__action.row-action(type="button" @click="edit")
      BriqIcon(name="icon-input-edit-icon")
    button.table__action.row-action(type="button" @click="remove")
      BriqIcon(name="icon-input-trash-icon")
</template>

<script>
import customFieldValidator from '@/vue/settings/application/custom-fields/customFieldValidator.js'

export default {
  props: {
    customField: {
      type: Object,
      validator: customFieldValidator,
    },
  },
  methods: {
    edit(event) {
      event.stopPropagation()
      this.$router.push({
        name: 'CustomFieldEdit',
        params: {
          customFieldKey: this.customField.key,
        },
      })
    },
    remove(event) {
      event.stopPropagation()
      this.$router.push({
        name: 'CustomFieldRemove',
        params: {
          customFieldKey: this.customField.key,
        },
      })
    },
  },
}
</script>

<style scoped lang="stylus">
tr:hover
  background #F1F3F6
  cursor pointer

td button
  vertical-align middle
</style>

<style lang="stylus">
svg
  vertical-align middle
</style>
